export default function EmailLink({ email = '' }) {
  return (
    <a className={` text-blue-600 underline hover:text-blue-800`} href={`mailto:${email}`}>
      {email}
    </a>
  );
}
